import { render, staticRenderFns } from "./AddClub.vue?vue&type=template&id=538b28cf&scoped=true"
import script from "./AddClub.vue?vue&type=script&lang=js"
export * from "./AddClub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b28cf",
  null
  
)

export default component.exports